module.exports = XLSX;


//////////////////
// WEBPACK FOOTER
// external "XLSX"
// module id = vz4p
// module chunks = 17